/**
 * 需求来源：docs/合作页、CJ Entity、Ads开户落地页3个/AI提示词.md（第2次提交 任务2）
 *   —— /partnership/home 按 partnership_home.html 完全重做，并接入 i18next 六国翻译机制。
 * 视觉/文案基准：docs/合作页、CJ Entity、Ads开户落地页3个/partnership_home.html。
 *
 * 本文件职责：收敛页面「所有静态可见文案」为 i18next key（前缀 partnershiphome-*），供各组件取用。
 * 注意事项：
 *  1. 同构安全：CommonJS，禁止 import/fs/path；一律经 typeof window 防御后再触碰浏览器对象。
 *  2. i18next 实例统一走 mcpLanding/i18nText.getI18next()（home 在二级目录，相对路径为 ../../mcpLanding/i18nText）。
 *  3. 简单文案用字面 i18next.t('key','English')；含变量（fullName / 分页数字 / 筛选值）的文案：
 *     - i18next 已初始化：用 odm 同款 { var, defaultValue } 对象形式让 i18next 正确插值；
 *     - 未初始化（SSR / 非浏览器）：t() 兜底可能返回非字符串，故统一再做一次手动 {{var}} 替换，保证英文兜底正确。
 *  4. 只放静态展示文案；接口返回的动态数据（合作方名称/描述/分类名等）不进翻译，保持接口原值。
 *  5. getConstants 在组件 render 时调用（非模块加载期），以便客户端 i18next 初始化后能拾取到目标语言文案。
 *
 * @param {string} [fullName] 站点全名 siteCheck.data('full-name')（如 CJdropshipping），用于 {{fullName}} 插值，缺省 'CJdropshipping'
 * @param {string} [siteName] 站点名 siteCheck.data('name')（如 CJ），用于 {{name}} 插值，缺省 'CJ'
 * @returns {{HERO:Object, DIRECTORY:Object, BRAND:Object, CTA:Object}}
 */
function getConstants(fullName, siteName) {
  var i18next = require('../../mcpLanding/i18nText').getI18next();
  var __fullName = fullName || 'CJdropshipping';
  // 260715：固定文案中的 CJ 改为站点名 siteCheck.data('name')；新增 -site key，旧 key 保留不再引用。
  var __name = siteName || 'CJ';
  var __ready = !!(i18next && i18next.isInitialized);

  // 变量插值兜底：res 非字符串（未初始化时 t 可能回传对象）时退回 def，再手动替换 {{var}}
  function subst(res, def, vars) {
    var s = typeof res === 'string' ? res : def;
    if (vars) {
      Object.keys(vars).forEach(function (k) {
        s = s.split('{{' + k + '}}').join(vars[k]);
      });
    }
    return s;
  }

  var HERO = {
    // 260715：旧 key partnershiphome-hero-label 停用（保留于词库），CJ→{{name}}
    label: subst(__ready ? i18next.t('partnershiphome-hero-label-site', { name: __name, defaultValue: '{{name}} Partner Network' }) : '{{name}} Partner Network', '{{name}} Partner Network', { name: __name }),
    title: i18next.t('partnershiphome-hero-title', 'The right partners for'),
    titleHighlight: i18next.t('partnershiphome-hero-title-highlight', 'every stage of ecommerce growth.'),
    desc: i18next.t('partnershiphome-hero-desc', 'Explore ecommerce platforms, marketing solutions, payment providers, logistics services and technology tools that can support your business from launch to global expansion.'),
    // 260714 第14次补充追加(需求㉚)：Explore Partners → 「Join {{fullName}}」，fullName=siteCheck.data('full-name')(经 fetch.js 传入)。
    // 260715 第17次补充(需求㊹)：按站点变量规则生成新 key partnershiphome-hero-explore-site，旧 key partnershiphome-hero-explore 停用(保留于词库)。
    explore: subst(__ready ? i18next.t('partnershiphome-hero-explore-site', { fullName: __fullName, defaultValue: 'Join {{fullName}}' }) : 'Join {{fullName}}', 'Join {{fullName}}', { fullName: __fullName }),
    become: i18next.t('partnershiphome-hero-become', 'Become a Partner'),
    // 环形轮盘上的业务分类标签（品牌名如 Shopify/amazon 等属专有名词，保持静态不翻译）
    ringLabels: [
      { cls: 'label-marketplace', text: i18next.t('partnershiphome-hero-ring-marketplace', 'Marketplace') },
      { cls: 'label-logistics', text: i18next.t('partnershiphome-hero-ring-logistics', 'Logistics') },
      { cls: 'label-marketing', text: i18next.t('partnershiphome-hero-ring-marketing', 'Marketing') },
      { cls: 'label-payment', text: i18next.t('partnershiphome-hero-ring-payment', 'Payments') },
      { cls: 'label-technology', text: i18next.t('partnershiphome-hero-ring-technology', 'Technology') },
      { cls: 'label-erp', text: i18next.t('partnershiphome-hero-ring-erp', 'ERP') },
    ],
  };

  var DIRECTORY = {
    kicker: i18next.t('partnershiphome-directory-kicker', 'Partner Directory'),
    title: i18next.t('partnershiphome-directory-title', 'Build a stronger ecommerce stack'),
    // 260715：旧 key partnershiphome-directory-desc 停用，CJ→{{name}}
    desc: subst(__ready ? i18next.t('partnershiphome-directory-desc-site', { name: __name, defaultValue: 'Search the {{name}} partner ecosystem by business category to find solutions that fit your current growth stage.' }) : 'Search the {{name}} partner ecosystem by business category to find solutions that fit your current growth stage.', 'Search the {{name}} partner ecosystem by business category to find solutions that fit your current growth stage.', { name: __name }),
    filterToggle: i18next.t('partnershiphome-directory-filter-toggle', 'Filter partners'),
    category: i18next.t('partnershiphome-directory-category', 'Partner category'),
    all: i18next.t('partnershiphome-directory-all', 'All'),
    resetAll: i18next.t('partnershiphome-directory-reset-all', 'Reset all filters'),
    searchPlaceholder: i18next.t('partnershiphome-directory-search-placeholder', 'Search partners'),
    sort: i18next.t('partnershiphome-directory-sort', 'Sort partners'),
    sortFeatured: i18next.t('partnershiphome-directory-sort-featured', 'Featured first'),
    sortAz: i18next.t('partnershiphome-directory-sort-az', 'Name A–Z'),
    sortZa: i18next.t('partnershiphome-directory-sort-za', 'Name Z–A'),
    noPartners: i18next.t('partnershiphome-directory-no-partners', 'No partners found'),
    clearSearch: i18next.t('partnershiphome-directory-clear-search', 'Clear partner search'),
    emptyTitle: i18next.t('partnershiphome-directory-empty-title', 'No matching partners'),
    emptyDesc: i18next.t('partnershiphome-directory-empty-desc', 'Try removing one or more filters or searching with a broader keyword.'),
    emptyReset: i18next.t('partnershiphome-directory-empty-reset', 'Reset filters'),
    cardVisit: i18next.t('partnershiphome-directory-card-visit', 'Visit partner'),
    prev: i18next.t('partnershiphome-directory-prev', 'Previous'),
    next: i18next.t('partnershiphome-directory-next', 'Next'),
    prevAria: i18next.t('partnershiphome-directory-prev-aria', 'Previous page'),
    nextAria: i18next.t('partnershiphome-directory-next-aria', 'Next page'),
    pagesAria: i18next.t('partnershiphome-directory-pages-aria', 'Partner directory pages'),

    // 结果计数：Showing {{start}}–{{end}} of {{total}} partner(s)
    resultMeta: function (start, end, total) {
      var vars = { start: start, end: end, total: total };
      if (Number(total) === 1) {
        var defS = 'Showing {{start}}–{{end}} of {{total}} partner';
        return subst(__ready ? i18next.t('partnershiphome-directory-result-meta-single', { start: start, end: end, total: total, defaultValue: 'Showing {{start}}–{{end}} of {{total}} partner' }) : defS, defS, vars);
      }
      var defP = 'Showing {{start}}–{{end}} of {{total}} partners';
      return subst(__ready ? i18next.t('partnershiphome-directory-result-meta', { start: start, end: end, total: total, defaultValue: 'Showing {{start}}–{{end}} of {{total}} partners' }) : defP, defP, vars);
    },
    // 激活筛选 chip：Category: {{value}}
    chipCategory: function (value) {
      var def = 'Category: {{value}}';
      return subst(__ready ? i18next.t('partnershiphome-directory-chip-category', { value: value, defaultValue: 'Category: {{value}}' }) : def, def, { value: value });
    },
    // 激活筛选 chip：Search: {{value}}
    chipSearch: function (value) {
      var def = 'Search: {{value}}';
      return subst(__ready ? i18next.t('partnershiphome-directory-chip-search', { value: value, defaultValue: 'Search: {{value}}' }) : def, def, { value: value });
    },
    // chip 移除按钮 aria：Remove {{value}} filter
    chipRemove: function (value) {
      var def = 'Remove {{value}} filter';
      return subst(__ready ? i18next.t('partnershiphome-directory-chip-remove', { value: value, defaultValue: 'Remove {{value}} filter' }) : def, def, { value: value });
    },
    // 分页页码 aria：Go to page {{page}}
    pageAria: function (page) {
      var def = 'Go to page {{page}}';
      return subst(__ready ? i18next.t('partnershiphome-directory-page-aria', { page: page, defaultValue: 'Go to page {{page}}' }) : def, def, { page: page });
    },
  };

  var BRAND = {
    // 260715：旧 key partnershiphome-brand-label 停用，CJ→{{name}}
    label: subst(__ready ? i18next.t('partnershiphome-brand-label-site', { name: __name, defaultValue: '{{name}} Brand Resources' }) : '{{name}} Brand Resources', '{{name}} Brand Resources', { name: __name }),
    title: i18next.t('partnershiphome-brand-title', 'Official brand assets'),
    desc: subst(__ready ? i18next.t('partnershiphome-brand-desc', { fullName: __fullName, defaultValue: 'Download approved {{fullName}} logos, icons and partner assets.' }) : 'Download approved {{fullName}} logos, icons and partner assets.', 'Download approved {{fullName}} logos, icons and partner assets.', { fullName: __fullName }),
    format: i18next.t('partnershiphome-brand-format', 'SVG · PNG'),
    download: i18next.t('partnershiphome-brand-download', 'Download'),
    cards: [
      { previewCls: 'cj-brand-card-primary', file: 'cj3.svg', title: i18next.t('partnershiphome-brand-primary-title', 'Primary logo'), text: i18next.t('partnershiphome-brand-primary-text', 'For light backgrounds'), alt: 'primary logo' },
      { previewCls: 'is-dark cj-brand-card-light', file: 'cj2_1.svg', title: i18next.t('partnershiphome-brand-light-title', 'Light logo'), text: i18next.t('partnershiphome-brand-light-text', 'For dark backgrounds'), alt: 'light logo' },
      { previewCls: 'is-orange cj-brand-card-icon', file: 'cj4.svg', title: i18next.t('partnershiphome-brand-icon-title', 'Brand icon'), text: i18next.t('partnershiphome-brand-icon-text', 'For digital placements'), alt: 'brand icon' },
      { previewCls: 'is-soft cj-brand-card-partner', file: 'cj1_1.svg', title: i18next.t('partnershiphome-brand-badge-title', 'Partner badge'), text: i18next.t('partnershiphome-brand-badge-text', 'For approved partners'), alt: 'partner badge' },
    ],
    // 下载按钮 aria：Download {{fullName}} {{asset}}
    downloadAria: function (asset) {
      var def = 'Download {{fullName}} {{asset}}';
      return subst(__ready ? i18next.t('partnershiphome-brand-download-aria', { fullName: __fullName, asset: asset, defaultValue: 'Download {{fullName}} {{asset}}' }) : def, def, { fullName: __fullName, asset: asset });
    },
  };

  var CTA = {
    eyebrow: subst(__ready ? i18next.t('partnershiphome-cta-eyebrow', { fullName: __fullName, defaultValue: '{{fullName}} Partner Program' }) : '{{fullName}} Partner Program', '{{fullName}} Partner Program', { fullName: __fullName }),
    title: subst(__ready ? i18next.t('partnershiphome-cta-title', { fullName: __fullName, defaultValue: 'Become a {{fullName}} Partner today' }) : 'Become a {{fullName}} Partner today', 'Become a {{fullName}} Partner today', { fullName: __fullName }),
    desc: subst(__ready ? i18next.t('partnershiphome-cta-desc', { fullName: __fullName, defaultValue: 'Partner with {{fullName}} to connect your products, services, or technology with ecommerce businesses around the world.' }) : 'Partner with {{fullName}} to connect your products, services, or technology with ecommerce businesses around the world.', 'Partner with {{fullName}} to connect your products, services, or technology with ecommerce businesses around the world.', { fullName: __fullName }),
    apply: i18next.t('partnershiphome-cta-apply', 'Apply to Become a Partner'),
  };

  return { HERO: HERO, DIRECTORY: DIRECTORY, BRAND: BRAND, CTA: CTA };
}

module.exports = { getConstants: getConstants };
